// Kırpma hedefleri: her yüzeyin menüde basıldığı kutuya göre. Sayılar menu/src/assets/css/dmenu.css
// ve BranchPicker'daki ölçülerden geliyor — orası değişirse burası da değişmeli.
//
// Hepsi FOTOĞRAF, o yüzden JPEG: aynı kadrajın PNG'si megabaytlarca sürerken JPEG birkaç yüz KB.
// Görseller storage.noxussoft.com üzerinden noxus-api'nin kotasına sayılıyor, fark doğrudan
// faturaya yazıyor. Marka görselleri (logo/amblem/yükleme ekranı) bu listede YOK — onlar şeffaflık
// istiyor ve PNG kalıyor (bkz. Brand/BrandSettings).
//
// 0.85 kalite: 0.9'un üstünde dosya hızla büyüyor, 0.8'in altında düz zeminlerde blok artefaktı
// çıkıyor. Menüdeki en büyük kutu bile 560px civarı, bu aralık fazlasıyla yetiyor.
const PHOTO = { type: "image/jpeg", quality: 0.85 };

// Kategori karosunun oranı SABİT DEĞİL: `Category.view` (1-6) karonun ızgarada kaç kolon ve kaç
// satır kapladığını belirliyor (.menu-grid-item.style-N) ve altı düzen altı farklı şekil demek.
//
// Izgara: 2 kolon, satır yüksekliği 100px (mobil) / 160px (masaüstü), boşluk 10 / 20,
// kapsayıcı %90 ekran / 560px. Buradan:
//
//   view  kapladığı            mobil      masaüstü    oran
//   1     1 kolon × 1 satır    188×100    270×160     ~1.78
//   2     2 kolon × 1 satır    387×100    560×160     ~3.70   ← çok geniş şerit
//   3     1 kolon × 2 satır    188×210    270×340     ~0.84
//   4     2 kolon × 2 satır    387×210    560×340     ~1.74
//   5     1 kolon × 3 satır    188×320    270×520     ~0.55   ← dikey
//   6     2 kolon × 3 satır    387×320    560×520     ~1.14
//
// Hepsine 16:9 dayatmak yalnızca 1 ve 4'e uyuyordu: geniş şeride (2) kadrajlanan fotoğrafın yanları
// kesiliyor, dikey karoya (5) ise üstü altı. Kullanıcı kadraj penceresinde zoom'la uğraşıp yine de
// menüde bambaşka bir çerçeve görüyordu.
//
// Değerler mobil ile masaüstü oranının ortası; ikisi arasındaki fark küçük ve `cover` kalanı yutuyor.
const CATEGORY_VIEWS = {
  1: { width: 1120, height: 630 },
  2: { width: 1480, height: 400 },
  3: { width: 720, height: 860 },
  4: { width: 1200, height: 690 },
  5: { width: 620, height: 1120 },
  6: { width: 1000, height: 880 },
};

const CATEGORY_VIEW_HINT = {
  1: "küçük kare kutu",
  2: "tam genişlik şerit",
  3: "dikey kutu",
  4: "büyük kare kutu",
  5: "uzun dikey kutu",
  6: "tam genişlik büyük kutu",
};

// Kadraj çerçevesi kategorinin GÖRÜNÜM SIRASINA göre. `view` formda 1-6 arası; bilinmeyen değer
// varsayılana düşüyor, kadrajsız kalmasın.
export const categoryTarget = (view) => {
  const key = CATEGORY_VIEWS[view] ? view : 1;

  return {
    ...PHOTO,
    aspect: CATEGORY_VIEWS[key],
    description: `Menüde ${CATEGORY_VIEW_HINT[key]} olarak görünür (görünüm ${key}); üstüne kategori adı biner.`,
  };
};

export const IMAGE_TARGETS = {
  // .item-box .item-image — 60px, aspect-ratio 1/1, object-fit cover. Öne çıkan üründe tam
  // genişlik ve kendi oranıyla basılıyor; kare orada da tutarlı duruyor.
  product: {
    ...PHOTO,
    aspect: { width: 800, height: 800 },
    description: "Menüde kare olarak görünür.",
  },
  // .bp-card — 128px sabit yükseklik, genişlik ekrana göre (.bp-inner tavanı 440px):
  //   360px ekran → 320×128 = 2.50    390px → 350×128 = 2.73    ≥480px → 440×128 = 3.44
  //
  // Hedef 16:9 idi ve `cover` genişliğe göre ölçeklediği için yükseklikte taşan kısım gidiyordu:
  // 2.73'lük kutuda görselin %35'i, 3.44'lük kutuda %48'i hiç görünmüyordu. Kullanıcı kadrajı
  // seçiyor, sonra yarısı kesiliyordu.
  //
  // 2.92 tipik telefon aralığının (2.50–3.44) ortası; uçlarda kalan fark `cover` ile yutuluyor.
  //
  // Görselin üstüne artık hiçbir katman binmiyor: karartma gradyanı (.bp-scrim) kaldırıldı, şube
  // adının okunurluğunu iki katmanlı metin gölgesi taşıyor. Yani fotoğraf menüde neyse o.
  branch: {
    ...PHOTO,
    aspect: { width: 1400, height: 480 },
    description:
      "Şube seçim kartında zemin olarak görünür; üstünde şube adı yazar.",
  },
};
